function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "number"
}, /*#__PURE__*/React.createElement("text", {
  transform: "translate(56.724 -738.265)",
  fontSize: 40,
  fill: "#24253a",
  fontFamily: "MyriadPro-Regular, Myriad Pro",
  letterSpacing: "0.002em"
}, "6", /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 228
}, "16"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 456
}, "26"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 684
}, "36"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 912
}, "46"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 1140
}, "56"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 1368
}, "66"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 1596
}, "76"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 1824
}, "86"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 2052
}, "96"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 2280
}, "106"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 2508
}, "116"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 2736
}, "126"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 2964
}, "136"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 3192
}, "146"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 3420
}, "156"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 3648
}, "166"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 3876
}, "176"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 4104
}, "186"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 4332
}, "196"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 4560
}, "206"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 4788
}, "216"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 5016
}, "226"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 5244
}, "236"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 5472
}, "246")));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M85.65,3H67.158a1.625,1.625,0,1,0,0,3.251H85.65A1.625,1.625,0,1,0,85.65,3Z",
  fill: "#e1b378"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.65,7.252H67.158a2.625,2.625,0,0,1,0-5.25H85.65a2.625,2.625,0,0,1,0,5.25ZM67.158,4a.625.625,0,0,0,0,1.25H85.65a.625.625,0,0,0,0-1.25Z",
  fill: "#2f3a5a"
}), /*#__PURE__*/React.createElement("rect", {
  x: 70.728,
  y: 1,
  width: 11.352,
  height: 7.329,
  fill: "#e1b378"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.563,3H43.071a1.625,1.625,0,1,0,0,3.251H61.563a1.625,1.625,0,1,0,0-3.251Z",
  fill: "#e1b378"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.563,7.252H43.071a2.625,2.625,0,0,1,0-5.25H61.563a2.625,2.625,0,0,1,0,5.25ZM43.071,4a.625.625,0,0,0,0,1.25H61.563a.625.625,0,0,0,0-1.25Z",
  fill: "#2f3a5a"
}), /*#__PURE__*/React.createElement("rect", {
  x: 46.641,
  y: 1,
  width: 11.352,
  height: 7.329,
  fill: "#e1b378"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("polygon", {
  points: "82.083 1.002 82.083 8.328 70.724 8.328 70.724 5.39 79.134 5.39 79.134 1.002 82.083 1.002",
  fill: "#bd8d5a"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("polygon", {
  points: "57.988 1.002 57.988 8.328 46.639 8.328 46.639 5.39 55.049 5.39 55.049 1.002 57.988 1.002",
  fill: "#bd8d5a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M82.08,9.329H70.729a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1H82.08a1,1,0,0,1,1,1V8.329A1,1,0,0,1,82.08,9.329Zm-10.352-2H81.08V2H71.729Z",
  fill: "#2f3a5a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.993,9.329H46.641a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1H57.993a1,1,0,0,1,1,1V8.329A1,1,0,0,1,57.993,9.329Zm-10.353-2h9.353V2H47.641Z",
  fill: "#2f3a5a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.532,6.108H37.918A3.228,3.228,0,0,0,34.69,9.335V110.6l6.035,16.212L46.759,110.6V9.335A3.227,3.227,0,0,0,43.532,6.108Z",
  fill: "#e1b378"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.752,6.3H61.138A3.228,3.228,0,0,0,57.91,9.523V110.788L63.945,127l6.035-16.212V9.523A3.227,3.227,0,0,0,66.752,6.3Z",
  fill: "#e1b378"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.082,6.3H84.468A3.228,3.228,0,0,0,81.24,9.523V110.788L87.275,127l6.035-16.212V9.523A3.228,3.228,0,0,0,90.082,6.3Z",
  fill: "#e1b378"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.761,9.331V110.6l-6.039,16.212-2.047-5.5,3.982-10.71V9.331a3.217,3.217,0,0,0-3.222-3.222h4.094A3.226,3.226,0,0,1,46.761,9.331Z",
  fill: "#bd8d5a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.985,9.524V110.787L63.946,127,61.9,121.487l3.982-10.7V9.524a3.235,3.235,0,0,0-3.232-3.232h4.1A3.235,3.235,0,0,1,69.985,9.524Z",
  fill: "#bd8d5a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.31,9.524V110.787L87.271,127l-2.047-5.5,3.982-10.71V9.524a3.226,3.226,0,0,0-3.222-3.232h4.094A3.235,3.235,0,0,1,93.31,9.524Z",
  fill: "#bd8d5a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M40.725,127.813a1,1,0,0,1-.937-.651l-6.034-16.212a1.009,1.009,0,0,1-.062-.349V9.335a4.232,4.232,0,0,1,4.228-4.228h5.614A4.232,4.232,0,0,1,47.76,9.335V110.6a1.014,1.014,0,0,1-.062.349l-6.035,16.212A1,1,0,0,1,40.725,127.813ZM35.69,110.42l5.034,13.525L45.76,110.42V9.335a2.23,2.23,0,0,0-2.228-2.228H37.918A2.23,2.23,0,0,0,35.69,9.335Zm11.069.18h0Z",
  fill: "#2f3a5a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.945,128a1,1,0,0,1-.937-.651l-6.035-16.212a1.014,1.014,0,0,1-.062-.349V9.522a4.232,4.232,0,0,1,4.228-4.228h5.614a4.232,4.232,0,0,1,4.228,4.228V110.788a1.009,1.009,0,0,1-.062.349l-6.034,16.212A1,1,0,0,1,63.945,128ZM58.91,110.608l5.035,13.525,5.034-13.525V9.522a2.23,2.23,0,0,0-2.228-2.228H61.138A2.23,2.23,0,0,0,58.91,9.522Zm11.069.18h0Z",
  fill: "#2f3a5a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.275,128a1,1,0,0,1-.937-.651L80.3,111.137a1.014,1.014,0,0,1-.062-.349V9.522a4.232,4.232,0,0,1,4.228-4.228h5.614A4.232,4.232,0,0,1,94.31,9.522V110.788a1.009,1.009,0,0,1-.062.349l-6.034,16.212A1,1,0,0,1,87.275,128ZM82.24,110.608l5.035,13.525,5.034-13.525V9.522a2.23,2.23,0,0,0-2.228-2.228H84.468A2.23,2.23,0,0,0,82.24,9.522Zm11.069.18h0Z",
  fill: "#2f3a5a"
}));

function SvgWicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWicket);
export default __webpack_public_path__ + "static/media/wicket.700abc61.svg";
export { ForwardRef as ReactComponent };